import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// This component handles the legacy Emergent auth flow (session_id in URL hash).
// The new Google OAuth PKCE flow goes directly through the backend callback
// and redirects to /dashboard without passing through this component.
const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Session invalide');
        navigate('/login');
        return;
      }

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        const user = response.data;
        toast.success(`Bienvenue ${user.name} !`);
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error("Erreur d'authentification");
        navigate('/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="text-center space-y-4">
        <div className="w-10 h-10 border-2 border-wid-red border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-white/50 text-sm">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
